import { defineComponent as _defineComponent } from 'vue'
import { ClientRiskCollateralProfile } from 'ah-api-gateways';
import { computed, PropType, ref, onMounted, nextTick, onBeforeUnmount } from 'vue';
import { formatNumberValue } from 'ah-common-lib/src/helpers/numbers';
import { getChartColorsForProfileUsageLevel } from '../../helpers/chartConfig';
import SimpleDoughnutChart from 'ah-reports/src/components/SimpleDoughnutChart.vue';
import FormattedCurrency from '../limitsAndCollateral/FormattedCurrency.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CreditLimitsOnForwardsAndOptions',
  props: {
  collateralProfileData: { type: Object as PropType<ClientRiskCollateralProfile>, required: true },
},
  emits: ["height-updated"],
  setup(__props, { emit }: { emit: ({ (e: 'height-updated', height: number): void }), expose: any, slots: any, attrs: any }) {

const props = __props;



const creditInfo = computed(() => [
  { label: 'Variation Margin Limit', value: props.collateralProfileData.variationMarginAmount },
  { label: 'Your Mark-to-Market Position', value: props.collateralProfileData.totalMarkToMarket },
  { label: 'Posted Collateral', value: props.collateralProfileData.totalPostedCollateral },
  { label: 'IM Requirement', value: props.collateralProfileData.totalInitialMarginCollateralFunding },
]);

/**
 * The code bellow has the purpose to get the component's height and pass it to the parent
 * This will guarantee that the Your Mark-to-Market Position's component always has the same height that this one
 */
const component = ref<InstanceType<typeof HTMLElement>>();



const totalCreaditAmountInUse = computed(() => {
  if (props.collateralProfileData.creditUsage < 0) {
    return 0;
  } else if (props.collateralProfileData.creditUsage > 1) {
    return 1;
  }

  return props.collateralProfileData.creditUsage;
});

const totalCreaditAmountRemaining = computed(() => 1 - totalCreaditAmountInUse.value);

const updateHeight = () => {
  if (component.value) {
    const componentHeight = component.value.clientHeight;
    emit('height-updated', componentHeight);
  }
};

const handleResize = () => {
  nextTick(updateHeight);
};

onMounted(() => {
  window.addEventListener('resize', handleResize);
  nextTick(updateHeight);
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize);
});

return { __sfc: true,props, creditInfo, component, emit, totalCreaditAmountInUse, totalCreaditAmountRemaining, updateHeight, handleResize, formatNumberValue, getChartColorsForProfileUsageLevel, SimpleDoughnutChart, FormattedCurrency }
}

})